import { Injectable, Inject, DOCUMENT } from "@angular/core";
import { ReplaySubject, Observable } from 'rxjs';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  // {
  //   name: "tween",
  //   src: "https://cdnjs.cloudflare.com/ajax/libs/tween.js/16.6.0/Tween.min.js",
  // },
  {
    name: "drift",
    src: "../../assets/js/drift.js",
  },
  // {
  //   name: "marker-cluster",
  //   src: "../../assets/js/leaflet.markercluster-src.js",
  // },
];

declare var document: any;

@Injectable()
export class DynamicScriptLoaderService {
  private scripts: any = {};
  loadedLibraries: { [href: string]: ReplaySubject<void> } = {};
  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src,
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name].loaded) {
        //load script
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = this.scripts[name].src;
        if (script.readyState) {
          //IE
          script.onreadystatechange = () => {
            if (
              script.readyState === "loaded" ||
              script.readyState === "complete"
            ) {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: "Loaded" });
            }
          };
        } else {
          //Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: "Loaded" });
          };
        }
        script.onerror = (error: any) =>
          resolve({ script: name, loaded: false, status: "Loaded" });
        document.getElementsByTagName("head")[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: "Already Loaded" });
      }
    });
  }

  loadLinkTag(data): Observable<void> {
    if (!data?.href) {
      return;
    }
    if (this.loadedLibraries[data?.href]) {
      return this.loadedLibraries[data?.href].asObservable();
    }
    this.loadedLibraries[data?.href] = new ReplaySubject();

    const style = this.document.createElement('link');
    for (const key in data) {
      style[key] = data[key];
    }


    style.onload = () => {
      this.loadedLibraries[data?.href].next();
      this.loadedLibraries[data?.href].complete();
    };
    style.onerror = (error) => {
      console.log('error in loading', error);
    };
    this.document.body.appendChild(style);
    // console.log('here', this.loadedLibraries);
    return this.loadedLibraries[data?.href].asObservable();
  }

  loadGoogleTagNoScript() {
    return new Promise((resolve, reject) => {
      if (!this.scripts['googleTagNoScript'] || !this.scripts['googleTagNoScript'].loaded) {
        //load script
    //     let noscript = document.createElement("noscript");
    //     noscript.innerHTML = `<iframe
    //     src="https://www.googletagmanager.com/ns.html?id=GTM-WFRN6ZR"
    //     height="0"
    //     width="0"
    //     style="display: none; visibility: hidden"
    //   ></iframe
    // >`
    //     if (noscript.readyState) {
        
    //       noscript.onreadystatechange = () => {
    //         if (
    //           noscript.readyState === "loaded" ||
    //           noscript.readyState === "complete"
    //         ) {
    //           noscript.onreadystatechange = null;
    //           this.scripts['googleTagNoScript'].loaded = true;
    //           resolve({ script: 'googleTagNoScript', loaded: true, status: "Loaded" });
    //         }
    //       };
    //     } else {
          
    //       noscript.onload = () => {
    //         this.scripts['googleTagNoScript'].loaded = true;
    //         resolve({ script: 'googleTagNoScript', loaded: true, status: "Loaded" });
    //       };
    //     }
    //     noscript.onerror = (error: any) =>
    //       resolve({ script: 'googleTagNoScript', loaded: false, status: "Loaded" });
    //     document.getElementsByTagName("body")[0].appendChild(noscript);
    //   } else {
    //     resolve({ script: 'googleTagNoScript', loaded: true, status: "Already Loaded" });
       }
    });
  }
  loadGoogleTagScript() {
    return new Promise((resolve, reject) => {
      if (!this.scripts['googleTagScript'] || !this.scripts['googleTagScript'].loaded) {
        
    //     let script = document.createElement("script");
    //     script.innerHTML = `(function (i, s, o, g, r, a, m) {
    //       i['GoogleAnalyticsObject'] = r;
    //       (i[r] =
    //         i[r] ||
    //         function () {
    //           (i[r].q = i[r].q || []).push(arguments);
    //         }),
    //         (i[r].l = 1 * new Date());
    //       (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    //       a.async = 1;
    //       a.src = g;
    //       m.parentNode.insertBefore(a, m);
    //     })(
    //       window,
    //       document,
    //       'script',
    //       'https://www.google-analytics.com/analytics.js',
    //       'ga'
    //     );`
    //     if (script.readyState) {
          
    //       script.onreadystatechange = () => {
    //         if (
    //           script.readyState === "loaded" ||
    //           script.readyState === "complete"
    //         ) {
    //           script.onreadystatechange = null;
    //           this.scripts['googleTagScript'].loaded = true;
    //           resolve({ script: 'googleTagScript', loaded: true, status: "Loaded" });
    //         }
    //       };
    //     } else {
          
    //       script.onload = () => {
    //         this.scripts['googleTagScript'].loaded = true;
    //         resolve({ script: 'googleTagScript', loaded: true, status: "Loaded" });
    //       };
    //     }
    //     script.onerror = (error: any) =>
    //       resolve({ script: 'googleTagScript', loaded: false, status: "Loaded" });
    //     document.getElementsByTagName("body")[0].appendChild(script);
    //   } else {
    //     resolve({ script: 'googleTagScript', loaded: true, status: "Already Loaded" });
      }
    });
  }
  loadGoogleTagHeadScript() {
    return new Promise((resolve, reject) => {
      if (!this.scripts['googleTagHeadScript'] || !this.scripts['googleTagHeadScript'].loaded) {
        
      //   let script = document.createElement("script");
      //   script.innerHTML = `(function (w, d, s, l, i) {
      //     w[l] = w[l] || [];
      //     w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      //     var f = d.getElementsByTagName(s)[0],
      //       j = d.createElement(s),
      //       dl = l != 'dataLayer' ? '&l=' + l : '';
      //     j.async = true;
      //     j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      //     f.parentNode.insertBefore(j, f);
      //   })(window, document, 'script', 'dataLayer', 'GTM-WFRN6ZR');`
      //   if (script.readyState) {
         
      //     script.onreadystatechange = () => {
      //       if (
      //         script.readyState === "loaded" ||
      //         script.readyState === "complete"
      //       ) {
      //         script.onreadystatechange = null;
      //         this.scripts['googleTagHeadScript'].loaded = true;
      //         resolve({ script: 'googleTagHeadScript', loaded: true, status: "Loaded" });
      //       }
      //     };
      //   } else {
          
      //     script.onload = () => {
      //       this.scripts['googleTagHeadScript'].loaded = true;
      //       resolve({ script: 'googleTagHeadScript', loaded: true, status: "Loaded" });
      //     };
      //   }
      //   script.onerror = (error: any) =>
      //     resolve({ script: 'googleTagHeadScript', loaded: false, status: "Loaded" });
      //   document.getElementsByTagName("head")[0].appendChild(script);
      // } else {
      //   resolve({ script: 'googleTagHeadScript', loaded: true, status: "Already Loaded" });
      }
    });
  }

  loadScriptTag(data): Observable<void> {
    if (!data?.src) {
      return;
    }
    if (this.loadedLibraries[data?.src]) {
      return this.loadedLibraries[data?.src].asObservable();
    }
    this.loadedLibraries[data?.src] = new ReplaySubject();

    const style = this.document.createElement('script');
    for (const key in data) {
      style[key] = data[key];
    }


    style.onload = () => {
      this.loadedLibraries[data?.src].next();
      this.loadedLibraries[data?.src].complete();
    };
    style.onerror = (error) => {
      console.log('error in loading', error);
    };
    this.document.body.appendChild(style);
    return this.loadedLibraries[data?.src].asObservable();
  }
  loadGooglePlatformBodyScript() {
    return new Promise((resolve, reject) => {
      if (!this.scripts['googlePlatformBodyScript'] || !this.scripts['googlePlatformBodyScript'].loaded) {
       
      //   let script = document.createElement("script");
      //   script.innerHTML = `(function (w, d, s, l, i) {
      //     w[l] = w[l] || [];
      //     w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      //     var f = d.getElementsByTagName(s)[0],
      //       j = d.createElement(s),
      //       dl = l != 'dataLayer' ? '&l=' + l : '';
      //     j.async = true;
      //     j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      //     f.parentNode.insertBefore(j, f);
      //   })(window, document, 'script', 'dataLayer', 'GTM-WFRN6ZR');`
      //   if (script.readyState) {
          
      //     script.onreadystatechange = () => {
      //       if (
      //         script.readyState === "loaded" ||
      //         script.readyState === "complete"
      //       ) {
      //         script.onreadystatechange = null;
      //         this.scripts['googlePlatformBodyScript'].loaded = true;
      //         resolve({ script: 'googlePlatformBodyScript', loaded: true, status: "Loaded" });
      //       }
      //     };
      //   } else {
          
      //     script.onload = () => {
      //       this.scripts['googlePlatformBodyScript'].loaded = true;
      //       resolve({ script: 'googlePlatformBodyScript', loaded: true, status: "Loaded" });
      //     };
      //   }
      //   script.onerror = (error: any) =>
      //     resolve({ script: 'googlePlatformBodyScript', loaded: false, status: "Loaded" });
      //   document.getElementsByTagName("body")[0].appendChild(script);
      // } else {
      //   resolve({ script: 'googlePlatformBodyScript', loaded: true, status: "Already Loaded" });
      }
    });
  }
}
